<template>
  <div>
  <div class="grid">
    <h2>North (UP)</h2>
    <div>
      <trlist name="SDAH_DDJ" v-bind:section="SDAH_DDJ" section_name="SDAH-DDJ"></trlist>
    </div>
    <div>
      <trlist name="DDJ_BP" v-bind:section="DDJ_BP" section_name="DDJ-BP"></trlist>
    </div>
    <div>
      <trlist name="BP_NH" v-bind:section="BP_NH" section_name="BP-NH"></trlist>
    </div>
    <div>
      <trlist name="NH_KYI" v-bind:section="NH_KYI" section_name="NH-KYI"></trlist>
    </div>
    <div>
      <trlist name="KYI_RHA" v-bind:section="KYI_RHA" section_name="KYI-RHA"></trlist>
    </div>
    <div>
      <trlist name="RHA_KLNP" v-bind:section="RHA_KLNP" section_name="RHA-KLNP"></trlist>
    </div>
    <div>
      <trlist name="KLNP_KNJ" v-bind:section="KLNP_KNJ" section_name="KLNP-KNJ"></trlist>
    </div>
    <div>
      <trlist name="KNJ_LGL" v-bind:section="KNJ_LGL" section_name="KNJ-LGL"></trlist>
    </div>
    <div>
      <trlist name="DDJ_BT" v-bind:section="DDJ_BT" section_name="DDJ-BT"></trlist>
    </div>
    <div>
      <trlist name="BT_BNJ" v-bind:section="BT_BNJ" section_name="BT-BNJ"></trlist>
    </div>
    <div>
      <trlist name="BT_HNB" v-bind:section="BT_HNB" section_name="BT-HNB"></trlist>
    </div>
    <div>
      <trlist name="RHA_GEDE" v-bind:section="RHA_GEDE" section_name="RHA-GEDE"></trlist>
    </div>
    <div>
      <trlist name="KLNP_STB" v-bind:section="KLNP_STB" section_name="KLNP-STB"></trlist>
    </div>
    <div>
      <trlist name="BNJ_RHA" v-bind:section="BNJ_RHA" section_name="BNJ-RHA"></trlist>
    </div>
    <div>
      <trlist name="DDJ_DKAE" v-bind:section="DDJ_DKAE" section_name="DDJ-DKAE"></trlist>
    </div>
  </div>

    <div class="grid">
      <h2>North (Down)</h2>
      <div>
        <trlist name="LGL_KNJ" v-bind:section="LGL_KNJ" section_name="LGL_KNJ"></trlist>
      </div>
      <div>
        <trlist name="KNJ_KLNP" v-bind:section="KNJ_KLNP" section_name="KNJ-KLNP"></trlist>
      </div>
      <div>
        <trlist name="KLNP_RHA" v-bind:section="KLNP_RHA" section_name="KLNP-RHA"></trlist>
      </div>
      <div>
        <trlist name="RHA_NH" v-bind:section="RHA_NH" section_name="RHA-KYI"></trlist>
      </div>
      <div>
        <trlist name="NH_BP" v-bind:section="NH_BP" section_name="NH-BP"></trlist>
      </div>
      <div>
        <trlist name="BP_DDJ" v-bind:section="BP_DDJ" section_name="BP-DDJ"></trlist>
      </div>
      <div>
        <trlist name="DDJ_SDAH" v-bind:section="DDJ_SDAH" section_name="DDJ-SDAH"></trlist>
      </div>
      <div>
        <trlist name="GEDE_RHA" v-bind:section="GEDE_RHA" section_name="GEDE-RHA"></trlist>
      </div>
      <div>
        <trlist name="STB_KLNP" v-bind:section="STB_KLNP" section_name="STB-KLNP"></trlist>
      </div>
      <div>
        <trlist name="BNJ_BT" v-bind:section="BNJ_BT" section_name="BNJ-BT"></trlist>
      </div>
      <div>
        <trlist name="HNB_BT" v-bind:section="HNB_BT" section_name="HNB-BT"></trlist>
      </div>
      <div>
        <trlist name="BT_DDJ" v-bind:section="BT_DDJ" section_name="BT-DDJ"></trlist>
      </div>
      <div>
        <trlist name="RHA_BNJ" v-bind:section="RHA_BNJ" section_name="RHA-BNJ"></trlist>
      </div>
      <div>
        <trlist name="DKAE_DDJ" v-bind:section="DKAE_DDJ" section_name="DDJ-DKAE"></trlist>
      </div>
    </div>

      <div class="grid">
        <h2>South (Down)</h2>
        <div>
          <trlist name="SDAH_BLN" v-bind:section="SDAH_BLN" section_name="SDAH-BLN"></trlist>
        </div>
        <div>
          <trlist name="BLN_SPR" v-bind:section="BLN_SPR" section_name="BLN-SPR"></trlist>
        </div>
        <div>
          <trlist name="SPR_BRP" v-bind:section="SPR_BRP" section_name="SPR-BRP"></trlist>
        </div>
        <div>
          <trlist name="SPR_CG" v-bind:section="SPR_CG" section_name="SPR-CG"></trlist>
        </div>
        <div>
          <trlist name="BRP_DH" v-bind:section="BRP_DH" section_name="BRP-DH"></trlist>
        </div>
        <div>
          <trlist name="BRP_LKPR" v-bind:section="BRP_LKPR" section_name="BRP-LKPR"></trlist>
        </div>
        <div>
          <trlist name="LKPR_NMKA" v-bind:section="LKPR_NMKA" section_name="LKPR-NMKA"></trlist>
        </div>
        <div>
          <trlist name="BLN_MJT" v-bind:section="BLN_MJT" section_name="BLN-MJT"></trlist>
        </div>
        <div>
          <trlist name="MJT_BGB" v-bind:section="MJT_BGB" section_name="MJT-BGB"></trlist>
        </div>
      </div>
      <div class="grid">
          <h2>South (up)</h2>
          <div>
            <trlist name="DH_BRP" v-bind:section="DH_BRP" section_name="DH-BRP"></trlist>
          </div>
          <div>
            <trlist name="BRP_SPR" v-bind:section="BRP_SPR" section_name="BRP-SPR"></trlist>
          </div>
          <div>
            <trlist name="SPR_BLN" v-bind:section="SPR_BLN" section_name="SPR-BLN"></trlist>
          </div>
          <div>
            <trlist name="BLN_SDAH" v-bind:section="BLN_SDAH" section_name="BLN-SDAH"></trlist>
          </div>
          <div>
            <trlist name="CG_SPR" v-bind:section="CG_SPR" section_name="CG-SPR"></trlist>
          </div>
          <div>
            <trlist name="NMKA_LKPR" v-bind:section="NMKA_LKPR" section_name="NMKA-LKPR"></trlist>
          </div>
          <div>
            <trlist name="LKPR_BRP" v-bind:section="LKPR_BRP" section_name="LKPR-BRP"></trlist>
          </div>
          <div>
            <trlist name="BGB_MJT" v-bind:section="BGB_MJT" section_name="BGB-MJT"></trlist>
          </div>
          <div>
            <trlist name="MJT_BLN" v-bind:section="MJT_BLN" section_name="MJT-BLN"></trlist>
          </div>
        </div>
      </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import trlist from './trlist.vue'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
import nest from './../js/nestgroup.js';
export default {
  name: 'runningtrains',
  components: {
    trlist,
  },
  data() {
    return {
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      errors: [],
      train: {},
      train_loading: false,
      trains: [],
      runningtrain: {},
      train_date: moment().format('DD/MM/YYYY HH:mm:ss'),
      isLoading: false,
      late_run_mnt: 4,
      min: -10,
      max: 60,
      lastupdate: moment().format('HH:mm:ss'),
      lastupdate_relative: moment().fromNow(),
      fetchTimer: null,
      SDAH_DDJ:[],
      DDJ_BP:[],
      BP_NH:[],
      NH_KYI:[],
      KYI_RHA:[],
      RHA_KLNP:[],
      KLNP_KNJ:[],
      KNJ_LGL:[],
      KLYM_KYI:[],
      KYI_KLYM:[],
      GEDE_RHA:[],
      RHA_GEDE:[],
      KLNP_STB:[],
      STB_KLNP:[],
      RHA_BNJ:[],
      BNJ_RHA:[],
      BNJ_BT:[],
      BT_DDJ:[],
      DDJ_SDAH:[],
      BT_HNB:[],
      HNB_BT:[],
      LGL_KNJ:[],
      KNJ_KLNP:[],
      RHA_NH:[],
      NH_BP:[],
      BP_DDJ:[],
      DDJ_MJT:[],
      MJT_DDJ:[],
      BLN_KGK:[],
      DDJ_DKAE:[],
      DKAE_DDJ:[],
      DKAE_BRPA:[],
      BRPA_DKAE:[],
      NH_BDC:[],
      BDC_KWAE:[],
      NH_KWAE:[],
      KWAE_BDC:[],
      BDC_NH:[],
      SDAH_BLN:[],
      BLN_MJT:[],
      MJT_BGB:[],
      BGB_MJT:[],
      MJT_BLN:[],
      BLN_SDAH:[],
      BLN_SPR:[],
      SPR_BLN:[],
      SPR_CG:[],
      CG_SPR:[],
      SPR_BRP:[],
      BRP_SPR:[],
      BRP_LKPR:[],
      LKPR_NMKA:[],
      NMKA_LKPR:[],
      LKPR_BRP:[],
      DH_BRP:[],
      NH_BWN:[],
      BWN_NH:[],
      BT_BNJ:[],
      DDJ_BT:[],
      KLNP_RHA:[],
      BRP_DH:[]

    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep', 'actDep', 'actArr']),
  },

  created() {

    this.initialize()
  },

  mounted() {
    this.fetchTimer = setInterval(() => this.initialize(), 60000);
  },

  destroyed() {
    clearInterval(this.fetchTimer);
  },
  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr']),
    initialize() {

      //      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      //      console.log(this.curDeviceId)
      this.isLoading = true

      var p = {
        // start_time: moment('2019-10-17 22:00:00').format('YYYY-MM-DD HH:mm:ss'),
        start_time: moment().format('YYYY-MM-DD HH:mm:ss'),
        late_run_mnt: this.late_run_mnt
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/allrunningtrains_for_website`, {
          params: p
        })
        .then(response => {
          var that = this
          that.trains = []
          var srl = 0
          _.forEach(response.data, function(o) {
            o.srl = srl + 1
            if (o.last_stn_late_dep != null) {
              o.status = o.last_stn_late_dep
            } else if (o.last_stn_late_arr != null) {
              o.status = o.last_stn_late_arr
            } else {
              o.status = 0
            }

            that.trains.push(o)
            srl = srl + 1
          });
          that.SDAH_DDJ = _.filter(that.trains, {section:'SDAH-DDJ'})
          that.DDJ_BP = _.filter(that.trains, {section:'DDJ-BP'})
          that.BP_NH = _.filter(that.trains, {section:'BP-NH'})
          that.NH_KYI = _.filter(that.trains, {section:'NH-KYI'})
          that.KYI_RHA = _.filter(that.trains, {section:'KYI-RHA'})
          that.RHA_KLNP = _.filter(that.trains, {section:'RHA-KLNP'})
          that.KLNP_KNJ = _.filter(that.trains, {section:'KLNP-KNJ'})
          that.KNJ_LGL = _.filter(that.trains, {section:'KNJ-LGL'})
          that.KLYM_KYI = _.filter(that.trains, {section:'KLYM-KYI'})
          that.KYI_KLYM = _.filter(that.trains, {section:'KYI-KLYM'})
          that.GEDE_RHA = _.filter(that.trains, {section:'GEDE-RHA'})
          that.RHA_GEDE = _.filter(that.trains, {section:'RHA-GEDE'})
          that.KLNP_STB = _.filter(that.trains, {section:'KLNP-STB'})
          that.STB_KLNP = _.filter(that.trains, {section:'STB-KLNP'})
          that.RHA_BNJ = _.filter(that.trains, {section:'RHA-BNJ'})
          that.BNJ_RHA = _.filter(that.trains, {section:'BNJ-RHA'})
          that.BNJ_BT = _.filter(that.trains, {section:'BNJ-BT'})
          that.BT_DDJ = _.filter(that.trains, {section:'BT-DDJ'})
          that.DDJ_SDAH = _.filter(that.trains, {section:'DDJ-SDAH'})
          that.BT_HNB = _.filter(that.trains, {section:'BT-HNB'})
          that.HNB_BT = _.filter(that.trains, {section:'HNB-BT'})
          that.LGL_KNJ = _.filter(that.trains, {section:'LGL-KNJ'})
          that.KNJ_KLNP = _.filter(that.trains, {section:'KNJ-KLNP'})
          that.RHA_NH = _.filter(that.trains, {section:'RHA-NH'})
          that.NH_BP = _.filter(that.trains, {section:'NH-BP'})
          that.BP_DDJ = _.filter(that.trains, {section:'BP-DDJ'})
          that.DDJ_MJT = _.filter(that.trains, {section:'DDJ-MJT'})
          that.MJT_DDJ = _.filter(that.trains, {section:'MJT-DDJ'})
          that.BLN_KGK = _.filter(that.trains, {section:'BLN-KGK'})
          that.DDJ_DKAE = _.filter(that.trains, {section:'DDJ-DKAE'})
          that.DKAE_DDJ = _.filter(that.trains, {section:'DKAE-DDJ'})
          that.DKAE_BRPA = _.filter(that.trains, {section:'DKAE-BRPA'})
          that.BRPA_DKAE = _.filter(that.trains, {section:'BRPA-DKAE'})
          that.NH_BDC = _.filter(that.trains, {section:'NH-BDC'})
          that.BDC_KWAE = _.filter(that.trains, {section:'BDC-KWAE'})
          that.NH_KWAE = _.filter(that.trains, {section:'NH-KWAE'})
          that.KWAE_BDC = _.filter(that.trains, {section:'KWAE-BDC'})
          that.BDC_NH = _.filter(that.trains, {section:'BDC-NH'})
          that.SDAH_BLN = _.filter(that.trains, {section:'SDAH-BLN'})
          that.BLN_MJT = _.filter(that.trains, {section:'BLN-MJT'})
          that.MJT_BGB = _.filter(that.trains, {section:'MJT-BGB'})
          that.BGB_MJT = _.filter(that.trains, {section:'BGB-MJT'})
          that.MJT_BLN = _.filter(that.trains, {section:'MJT-BLN'})
          that.BLN_SDAH = _.filter(that.trains, {section:'BLN-SDAH'})
          that.BLN_SPR = _.filter(that.trains, {section:'BLN-SPR'})
          that.SPR_BLN = _.filter(that.trains, {section:'SPR-BLN'})
          that.SPR_CG = _.filter(that.trains, {section:'SPR-CG'})
          that.CG_SPR = _.filter(that.trains, {section:'CG-SPR'})
          that.SPR_BRP = _.filter(that.trains, {section:'SPR-BRP'})
          that.BRP_SPR = _.filter(that.trains, {section:'BRP-SPR'})
          that.BRP_LKPR = _.filter(that.trains, {section:'BRP-LKPR'})
          that.LKPR_NMKA = _.filter(that.trains, {section:'LKPR-NMKA'})
          that.NMKA_LKPR = _.filter(that.trains, {section:'NMKA-LKPR'})
          that.LKPR_BRP = _.filter(that.trains, {section:'LKPR-BRP'})
          that.DH_BRP = _.filter(that.trains, {section:'DH-BRP'})
          that.NH_BWN = _.filter(that.trains, {section:'NH-BWN'})
          that.BWN_NH = _.filter(that.trains, {section:'BWN-NH'})
          that.BT_BNJ = _.filter(that.trains, {section:'BT-BNJ'})
          that.DDJ_BT = _.filter(that.trains, {section:'DDJ-BT'})
      //    console.log(that.SDAH_DDJ)
        //  that.runningtrain = nest(that.trains, ['north_south', 'up_dn', 'section'])
          // console.log('trains', that.runningtrain)
          this.isLoading = false
        })
        .catch(e => {
          this.errors.push(e)
          console.log(e)
          this.isLoading = false
        })
    },

    refreshData() {

    },

    //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
    onRowClick($event) {
      console.log($event);
      this.updateCurTrainNo($event.train_no)
      this.updateCurTrainDate(moment($event.train_date).format("YYYY-MM-DD"))
      this.updateCurDeviceId($event.device_id)
      this.updateCurDeviceName($event.device_name)
      this.updateCurOrg($event.org)
      this.updateCurDep($event.dep)
      this.updateActDep($event.act_dep)
      this.updateCurDest($event.dest)
      this.updateCurArr($event.arr)
      this.updateActArr($event.act_arr)
      this.$router.push({
        name: 'Positions'
      })
    },
    getFormattedDate(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("DD/MM/YYYY")
    },
    getFormattedTime(t) {
      return moment.utc(t).format("HH:mm:ss")
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    }
  }
}
</script>
<style scoped>
.parent-container {
  max-height:600px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 1rem;
}
.grid > div {
  background: #EDE7F6;
  padding: 1.5rem;
  border-radius: 1rem;
}
body {
  margin: 2rem;
  font: 12px system-ui;
}
</style>
